import { render, staticRenderFns } from "./LDO.vue?vue&type=template&id=96422de2&"
import script from "./LDO.vue?vue&type=script&lang=js&"
export * from "./LDO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports